import {useEffect, useState} from 'react';
import {
  useCurrentRefinements,
  useClearRefinements,
  // @ts-ignore:next-line
} from 'react-instantsearch';
import {IconClose} from '../elements/Icon';

export function CurrentFilters() {
  const {items} = useCurrentRefinements();
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(!!items.length);
  }, [items]);

  const getItemLabel = (attribute: string) => {
    switch (attribute) {
      case 'options.color':
        return 'väri';
      case 'vendor':
        return 'tuotemerkki';
      case 'price':
        return 'hinta';
      case 'product_type':
        return 'tuotetyyppi';
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className="collection-current-filters">
      <ClearFilters />
      {items.map((item: any) =>
        item.refinements.map((refinement: any, index: number) => {
          return (
            <div
              key={`refinement-${refinement.attribute}-${index}`}
              className="inline-flex items-center bg-black py-1 px-2 mr-1 mb-1 text-white uppercase text-xs"
            >
              <span>
                {getItemLabel(refinement.attribute)}:{' '}
                {refinement.label +
                  ('price' === refinement.attribute ? ' €' : '')}
              </span>
              <button className="ml-2" onClick={() => item.refine(refinement)}>
                <IconClose />
              </button>
            </div>
          );
        }),
      )}
    </div>
  );
}

function ClearFilters() {
  const {refine} = useClearRefinements();

  return (
    <div className="block lg:inline-flex">
      <button
        className="underline mb-4 mr-4 text-sm lg:mb-0"
        onClick={() => refine()}
      >
        Tyhjennä suodatin
      </button>
    </div>
  );
}
